import renderItemNode from './renderitemnode.js';
import triggerOne from '../../trigger/_triggerone.js';
import defs from '../../_core/defs.js';
import matreshkaError from '../../_helpers/matreshkaerror.js';
import forEach from '../../_helpers/foreach.js';
import getAlreadyRendered from './getalreadyrendered.js';
import removeNode from '../../_helpers/removenode.js';
// this function renders inserted items if possible when recreate method is called
export default function processRecreate(_ref) {
  var self = _ref.self,
    selfDef = _ref.selfDef,
    eventOptions = _ref.eventOptions,
    container = _ref.container;
  var removed = eventOptions.removed,
    silent = eventOptions.silent;
  var selfId = selfDef.id;
  // iterate over removed items and remove their nodes
  forEach(removed, function (item) {
    var itemDef = defs.get(item);
    if (itemDef) {
      var renderedInArrays = itemDef.renderedInArrays;
      var node = renderedInArrays == null ? void 0 : renderedInArrays[selfId];
      if (renderedInArrays && node) {
        delete renderedInArrays[selfId];
        removeNode(node.__replacedByNode);
        removeNode(node);
      }
    }
  });
  var alreadyRenderedMap = {};
  // iterate over all items
  // the following approach allows to throw an error when two added objects are the same
  // (not only compare existing items with old ones)
  forEach(self, function (item) {
    if (item && typeof item === 'object') {
      var itemDef = defs.get(item);
      var alreadyRenderedNode;
      if (itemDef) {
        alreadyRenderedNode = getAlreadyRendered({
          item: item,
          selfDef: selfDef
        });
      }
      if (itemDef && alreadyRenderedNode) {
        // if an item is already rendered (old item)
        if (itemDef.id in alreadyRenderedMap) {
          // if an item is rendered twice throw an error
          throw matreshkaError('array:add_render_twice');
        }
        alreadyRenderedMap[itemDef.id] = true;
        container.appendChild(alreadyRenderedNode);
      } else {
        // this is newly added item
        var _renderItemNode = renderItemNode({
            selfDef: selfDef,
            self: self,
            item: item,
            eventOptions: eventOptions
          }),
          node = _renderItemNode.node,
          itemEventOptions = _renderItemNode.itemEventOptions;
        if (node) {
          // renderItemNode gave the item a definition; a second place of the item finds its node above and throws
          itemDef = itemDef || defs.get(item);
          alreadyRenderedMap[itemDef.id] = true;
          container.appendChild(node);
          if (!silent) {
            triggerOne(item, 'afterrender', itemEventOptions);
          }
        }
      }
    }
  });
}